import { USER_ROLES_ENUM } from 'src/libs/constant'

const R = USER_ROLES_ENUM

/**
 * Map permission key -> array of roles that grant that permission.
 * Two special permissions (canUseStudentMenu, canUseTeacherSalary) have extra
 * conditions involving classType — handled as overrides in SidebarMenu.js.
 */
export const PERMISSION_ROLES = {
  canUseUserModule: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.MANAGER_TEACHER,
    R.MANAGER_SALE
  ],
  canUseTeacherUser: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.MANAGER_TEACHER,
    R.MANAGER_SALE,
    R.EMPLOYEE_CUSTOMER_CARE
  ],
  canUseClassDemoMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_MONITOR,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER,
    R.MANAGER_SALE,
    R.EMPLOYEE_SALE,
    R.CUSTOMER_CARE_SPECIALIST
  ],
  canUseAssignClassDemoMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_MONITOR,
    R.MANAGER_TEACHER,
    R.MANAGER_SALE,
    R.EMPLOYEE_SALE
  ],
  canUseClassRegularMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_MONITOR,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER,
    R.EMPLOYEE_SALE,
    R.MANAGER_SALE,
    R.EMPLOYEE_COLLABORATOR_CLASS,
    R.EMPLOYEE_CUSTOMER_CARE,
    R.CUSTOMER_CARE_SPECIALIST
  ],
  canUseClassTrainingMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.TRAINING_SPECIALIST
  ],
  canUseMakeupLessonMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_SALE,
    R.MANAGER_SALE,
    R.EMPLOYEE_COLLABORATOR_CLASS,
    R.EMPLOYEE_CUSTOMER_CARE,
    R.CUSTOMER_CARE_SPECIALIST
  ],
  canUseTeacherBookingMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_CUSTOMER_CARE,
    R.EMPLOYEE_COLLABORATOR_CLASS,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER
  ],
  canUseTeacherCancelSchedule: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER
  ],
  canUseSessionSummaryMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_COLLABORATOR_CLASS,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_CUSTOMER_CARE
  ],
  canUseSessionRegularSummaryMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_COLLABORATOR_CLASS,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_CUSTOMER_CARE,
    R.CUSTOMER_CARE_SPECIALIST
  ],
  canUseConfigCalendarTeacherMenu: [
    R.ADMIN
  ],
  canUseMonitorTicketMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_MONITOR,
    R.MANAGER_SALE,
    R.EMPLOYEE_SALE,
    R.EMPLOYEE_CUSTOMER_CARE,
    R.EMPLOYEE_COLLABORATOR_CLASS
  ],
  canUseTechnicalTicketMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TECHNICAL,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_MONITOR,
    R.MANAGER_SALE,
    R.EMPLOYEE_SALE,
    R.EMPLOYEE_COLLABORATOR_CLASS,
    R.CUSTOMER_CARE_SPECIALIST
  ],
  canUseRescheduleDemoTickketMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MONITOR,
    R.MANAGER_TEACHER
  ],
  canUseFeedBackDemoMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER,
    R.MANAGER_SALE,
    R.EMPLOYEE_SALE,
    R.EMPLOYEE_COLLABORATOR_CLASS
  ],
  canUseFeedBackSessionMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER,
    R.EMPLOYEE_CUSTOMER_CARE
  ],
  canUseReportResultMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER,
    R.MANAGER_SALE,
    R.EMPLOYEE_CUSTOMER_CARE,
    R.EMPLOYEE_SALE
  ],
  canUseCareTicketMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_CUSTOMER_CARE,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER,
    R.MANAGER_SALE,
    R.EMPLOYEE_SALE
  ],
  canUseAssignRegClassMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_SALE,
    R.MANAGER_SALE,
    R.EMPLOYEE_COLLABORATOR_CLASS,
    R.EMPLOYEE_CUSTOMER_CARE,
    R.CUSTOMER_CARE_SPECIALIST
  ],
  canUseClassRegularSessionMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_CUSTOMER_CARE,
    R.EMPLOYEE_MONITOR,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER,
    R.MANAGER_SALE,
    R.EMPLOYEE_SALE,
    R.CUSTOMER_CARE_SPECIALIST
  ],
  canUseTeachingSchedule: [
    R.EMPLOYEE_TEACHER
  ],
  canUseSearchSessionHomework: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_MONITOR,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER,
    R.MANAGER_SALE,
    R.EMPLOYEE_SALE,
    R.CUSTOMER_CARE_SPECIALIST
  ],
  canUseStudentMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_CUSTOMER_CARE,
    R.EMPLOYEE_SALE,
    R.MANAGER_SALE,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_COLLABORATOR_CLASS,
    R.CUSTOMER_CARE_SPECIALIST
  ],
  canUseStudentCareMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.MANAGER_SALE,
    R.CUSTOMER_CARE_SPECIALIST,
    R.EMPLOYEE_CUSTOMER_CARE,
    R.EMPLOYEE_SALE
  ],
  canUseStudentCareTicket: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.MANAGER_SALE,
    R.CUSTOMER_CARE_SPECIALIST
  ],
  canUseStudentCarePeriodicMenu: [
    R.ADMIN,
    R.MANAGER,
    R.EMPLOYEE_MINISTRY,
    R.CUSTOMER_CARE_SPECIALIST
  ],
  canUseStudentExpireMenu: [
    R.ADMIN,
    R.MANAGER,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_SALE,
    R.MANAGER_SALE,
    R.CUSTOMER_CARE_SPECIALIST,
    R.EMPLOYEE_CUSTOMER_CARE
  ],
  canUpdateClassinCookie: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR
  ],
  canUseUserConfig: [
    R.ADMIN,
    R.MANAGER
  ],
  canUseConfigLearningModel: [
    R.ADMIN
  ],
  canUseConfig: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.TRAINING_SPECIALIST
  ],
  canUseScoreWeightConfig: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.TRAINING_SPECIALIST
  ],
  canUseTutorConfig: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER
  ],
  canUseStudentTransferMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_COLLABORATOR_CLASS,
    R.EMPLOYEE_CUSTOMER_CARE,
    R.MANAGER_SALE
  ],
  canUseBreachRulesConfig: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER
  ],
  canUseSalaryConfig: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER
  ],
  canUseWaitingConfirm: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER
  ],
  canUseFindTeacherBackup: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER
  ],
  canUseListObserveBackup: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER
  ],
  canUseDutyBackup: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER
  ],
  canUseAbsenceMenu: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER
  ],
  canUseRegisterTeacherAbsence: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER
  ],
  canUseTeacherQuiJobAbsence: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER
  ],
  canUseManageTeacherAbsence: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER
  ],
  canUseTeacherSalary: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER
  ],
  canUseManageTeacherAndQualityControl: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER,
    R.EMPLOYEE_MINISTRY,
    R.QUALITY_CONTROL,
    R.QUALITY_ASSURANCE,
    R.TRAINING_SPECIALIST
  ],
  canUseTutorQualityReport: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_TEACHER,
    R.TRAINING_SPECIALIST
  ],
  canUseManageCancelSession: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER
  ],
  canUseOperate: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_MINISTRY,
    R.EMPLOYEE_MONITOR,
    R.EMPLOYEE_TECHNICAL,
    R.EMPLOYEE_COLLABORATOR_CLASS,
    R.EMPLOYEE_CUSTOMER_CARE,
    R.MANAGER_TEACHER,
    R.MANAGER_SALE,
    R.EMPLOYEE_SALE
  ],
  canUseMakeUpSessionNumberConfig: [
    R.ADMIN
  ],
  canUseQualityControlSession: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_MINISTRY,
    R.QUALITY_CONTROL,
    R.EMPLOYEE_TEACHER,
    R.TRAINING_SPECIALIST
  ],
  canUseQualityAssuranceSession: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_MINISTRY,
    R.QUALITY_ASSURANCE,
    R.EMPLOYEE_TEACHER,
    R.TRAINING_SPECIALIST
  ],
  canUseQualityControlSystem: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_TEACHER,
    R.EMPLOYEE_MINISTRY,
    R.QUALITY_CONTROL
  ],
  canUseCustomSurvey: [
    R.ADMIN,
    R.MANAGER,
    R.EMPLOYEE_CUSTOMER_CARE
  ],
  canUseFeedback: [
    R.ADMIN,
    R.MANAGER,
    R.MANAGER_MONITOR,
    R.EMPLOYEE_COLLABORATOR_CLASS,
    R.EMPLOYEE_MONITOR,
    R.EMPLOYEE_TECHNICAL,
    R.EMPLOYEE_MINISTRY,
    R.CUSTOMER_CARE_SPECIALIST,
    R.MANAGER_TEACHER,
    R.MANAGER_SALE,
    R.EMPLOYEE_SALE,
    R.EMPLOYEE_CUSTOMER_CARE
  ],
  canUseAdminConfig: [
    R.ADMIN
  ],
  canUseSale: [
    R.EMPLOYEE_SALE,
    R.MANAGER_SALE
  ]
}
